import React, { Component } from "react";
import "./LeftMenu.css";
import logo from "../../images/complet_logo_2.png";
import graph from "../../images/task.png";
import { Link } from "react-router-dom";
import { i18n } from "../../translate/i18n";
import { studioIcon, couponIcon, langindpageIcon, branchIcon, customersIcon, reportsIcon } from "../data/menuIcons";
import settingsIcons from "../../images/settings.svg"
class LeftMenu extends Component {
  constructor() {
    super();
    this.state = {};
  }

  liveMenu() {

    var estab = document.getElementById("Estab");
    if (estab) {
      estab.addEventListener("click", function (e) {
        document.querySelector(".menuEstab").classList.toggle("specialClass");
      });
    }

    var customers = document.getElementById("customers");
    if (customers) {
      customers.addEventListener("click", function (e) {
        var itemmenu = document.querySelector(".customersmenu"); // Using a class instead, see note below.
        itemmenu.classList.toggle("specialClass");
      });
    }

    var reports = document.getElementById("reports");
    if (reports) {
      reports.addEventListener("click", function (e) {
        var itemmenu = document.querySelector(".reportsmenu"); // Using a class instead, see note below.
        itemmenu.classList.toggle("specialClass");
      });
    }


    var menu = document.getElementById("profile");
    if (menu) {
      menu.addEventListener("click", function (e) {
        var itemmenu = document.querySelector(".menu1"); // Using a class instead, see note below.
        itemmenu.classList.toggle("specialClass");
      });
    }

    var leadpagemenu = document.getElementById("leadpage");
    if (leadpagemenu) {
      leadpagemenu.addEventListener("click", function (e) {
        var itemmenu = document.querySelector(".leadpagemenu");
        itemmenu.classList.toggle("specialClass");
      });
    }

    var communicationmenu = document.getElementById("Communication");
    if (communicationmenu) {
      communicationmenu.addEventListener("click", function (e) {
        var itemmenu = document.querySelector(".communicationmenu");
        itemmenu.classList.toggle("specialClass");
      });
    }

    var menu2 = document.getElementById("profile2");
    if (menu2) {
      menu2.addEventListener("click", function (e) {
        var itemmenu = document.querySelector(".menu2"); // Using a class instead, see note below.
        itemmenu.classList.toggle("specialClass");
      });
    }
  }

  componentDidMount() {
    this.liveMenu();
  }

  render() {
    return (
      <div className="row leftMenu shadow bg-white">
        {/* Primeiro bloco do menu ***Menu Esquerdo */}
        <div className="firstBlockMenu">
          <img className="logoLarge" src={logo} alt="Logo" />
        </div>

        {/* <!--Segundo bloco do menu--> */}
        <div className="secondBlockMenu content">
          <div className="">
            <hr style={{ width: "90%", marginTop: "0px" }} />
            <li className="item" id="dashboard" title="dashboard">
              <div className="col">
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <div className="btn">
                    <Link to="/dashboard">
                      <svg className="svg-icon" viewBox="0 0 20 20">
                        <path
                          fill="none"
                          d="M12.173,16.086c0.72,0,1.304-0.584,1.304-1.305V6.089c0-0.72-0.584-1.304-1.304-1.304c-0.721,0-1.305,0.584-1.305,1.304v8.692C10.868,15.502,11.452,16.086,12.173,16.086z M11.738,6.089c0-0.24,0.194-0.435,0.435-0.435s0.435,0.194,0.435,0.435v8.692c0,0.24-0.194,0.436-0.435,0.436s-0.435-0.195-0.435-0.436V6.089zM16.52,16.086c0.72,0,1.304-0.584,1.304-1.305v-11.3c0-0.72-0.584-1.304-1.304-1.304c-0.721,0-1.305,0.584-1.305,1.304v11.3C15.215,15.502,15.799,16.086,16.52,16.086z M16.085,3.481c0-0.24,0.194-0.435,0.435-0.435s0.435,0.195,0.435,0.435v11.3c0,0.24-0.194,0.436-0.435,0.436s-0.435-0.195-0.435-0.436V3.481z M3.48,16.086c0.72,0,1.304-0.584,1.304-1.305v-3.477c0-0.72-0.584-1.304-1.304-1.304c-0.72,0-1.304,0.584-1.304,1.304v3.477C2.176,15.502,2.76,16.086,3.48,16.086z M3.045,11.305c0-0.24,0.194-0.435,0.435-0.435c0.24,0,0.435,0.194,0.435,0.435v3.477c0,0.24-0.195,0.436-0.435,0.436c-0.24,0-0.435-0.195-0.435-0.436V11.305z M18.258,16.955H1.741c-0.24,0-0.435,0.194-0.435,0.435s0.194,0.435,0.435,0.435h16.517c0.24,0,0.435-0.194,0.435-0.435S18.498,16.955,18.258,16.955z M7.826,16.086c0.72,0,1.304-0.584,1.304-1.305V8.696c0-0.72-0.584-1.304-1.304-1.304S6.522,7.977,6.522,8.696v6.085C6.522,15.502,7.106,16.086,7.826,16.086z M7.392,8.696c0-0.239,0.194-0.435,0.435-0.435s0.435,0.195,0.435,0.435v6.085c0,0.24-0.194,0.436-0.435,0.436s-0.435-0.195-0.435-0.436V8.696z"
                        ></path>
                      </svg>
                    </Link>
                  </div>
                </div>
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <label style={{ fontSize: "smaller", fontFamily: "Roboto", color: "#755ff5" }}>{i18n.t("menu.leftmenu.dashboard")}</label>
                </div>
              </div>
            </li>

            <hr style={{ width: "90%", marginTop: "0px" }} />

            <li className="item_" id="Studio" title="Studio">
              <div className="col">
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <div className="btn">
                    <Link to="/studio">
                      <img
                        style={{ display: "block" }}
                        src={graph}
                        alt="Logo"
                        height="28px"
                        width="28px"
                        title="Studio"
                      />
                    </Link>
                  </div>
                </div>
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <label style={{ fontSize: "smaller", fontFamily: "Roboto", color: "#755ff5" }}>{i18n.t("menu.leftmenu.studiomodule")}</label>
                </div>
              </div>
            </li>

            <hr style={{ width: "90%", marginTop: "0px" }} />

            <li className="item_" id="Configs" title="Configs">
              <div className="col">
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <div className="btn">
                    <Link to="/settings">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        x="0"
                        y="0"
                        version="1.1"
                        viewBox="0 0 28 28"
                        xmlSpace="preserve"
                      >
                        <image
                          width="28"
                          height="28"
                          x="0"
                          y="0"
                          href={settingsIcons}
                        ></image>
                      </svg>
                    </Link>
                  </div>
                </div>
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <label style={{ fontSize: "smaller", fontFamily: "Roboto", color: "#755ff5" }}>{i18n.t("menu.leftmenu.configModule")}</label>
                </div>
              </div>
            </li>


            <hr style={{ width: "90%", marginBottom: "4px", marginTop: "0px" }} />



            {/* MENU CUSTOMERS */}
            <li
              className="item_"
              id="customers"
              title={i18n.t("menu.leftmenu.couponmodule")}
            >

              <div className="col">
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <div className="btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      x="0"
                      y="0"
                      version="1.1"
                      viewBox="0 0 28 28"
                      xmlSpace="preserve"
                    >
                      <image
                        width="28"
                        height="28"
                        x="0"
                        y="0"
                        href={customersIcon}
                      ></image>
                    </svg>
                  </div>
                </div>
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <label style={{ fontSize: "smaller", fontFamily: "Roboto", color: "#755ff5" }}>
                    Clientes
                  </label>
                </div>
              </div>
              <div id="itemMenu" className="smenu customersmenu">
                <Link
                  to="customers"
                  title={i18n.t("menu.leftmenu.couponmoduleitemcoupons")}
                >
                  <label>Ver/Editar Clientes</label>
                </Link>
              </div>
            </li>
            {/* MENU CUSTOMERS */}


            <hr style={{ width: "90%", marginBottom: "4px", marginTop: "0px" }} />
            {/* MENU REPORTS */}
            <li
              className="item_"
              id="reports"
              title={i18n.t("menu.leftmenu.reports")}
            >

              <div className="col">
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <div className="btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      x="0"
                      y="0"
                      version="1.1"
                      viewBox="0 0 28 28"
                      xmlSpace="preserve"
                    >
                      <image
                        width="28"
                        height="28"
                        x="0"
                        y="0"
                        href={reportsIcon}
                      ></image>
                    </svg>
                  </div>
                </div>
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <label style={{ fontSize: "smaller", fontFamily: "Roboto", color: "#755ff5" }}>
                    {i18n.t("menu.leftmenu.reports")}
                  </label>
                </div>
              </div>
              <div id="itemMenu" className="smenu reportsmenu">
                <Link
                  to="/reports?type=allCashBack"
                  title={i18n.t("menu.leftmenu.cashbackreports")}
                >
                  <label>{i18n.t("menu.leftmenu.cashbackreports")}</label>
                </Link>
                <Link
                  to="/reports?type=allPoints"
                  title={i18n.t("menu.leftmenu.pointsreport")}
                >
                  <label>{i18n.t("menu.leftmenu.pointsreport")}</label>
                </Link>
                <Link
                  to="/reports/sms-comtele"
                  title={i18n.t("menu.leftmenu.comtelesmsreport")}
                >
                  <label>{i18n.t("menu.leftmenu.comtelesmsreport")}</label>
                </Link>
                <Link
                  to="/reports/push"
                  title={i18n.t("menu.leftmenu.pushreport")}
                >
                  <label>{i18n.t("menu.leftmenu.pushreport")}</label>
                </Link>
              </div>
            </li>
            {/* MENU REPORTS */}
            <hr style={{ width: "90%", marginBottom: "4px", marginTop: "0px" }} />

            {/* MENU COMUNICAÇÃO */}
            <li className="item_" id="Communication" title="Módulo Comunicação">
              <div className="col">
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <div className="btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      x="0"
                      y="0"
                      version="1.1"
                      viewBox="0 0 28 28"
                      xmlSpace="preserve"
                    >
                      <image
                        width="28"
                        height="28"
                        x="0"
                        y="0"
                        href={studioIcon}
                      ></image>
                    </svg>
                  </div>
                </div>
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <label style={{ fontSize: "smaller", fontFamily: "Roboto", color: "#755ff5" }}>Comunicação</label>
                </div>
              </div>

              <div id="itemMenu" className="smenu communicationmenu">
                <Link
                  to="contacts"
                  title={i18n.t("menu.leftmenu.communicationmoduleitemcontacts")}
                >
                  <label>{i18n.t("menu.leftmenu.communicationmoduleitemcontacts")}</label>
                </Link>
                {/* <Link
                  to="customers"
                  title={i18n.t("menu.leftmenu.communicationmoduleitemcustomers")}
                >
                  <label>{i18n.t("menu.leftmenu.communicationmoduleitemcustomers")}</label>
                </Link> */}
                <Link
                  to="campaignsview"
                  title={i18n.t("menu.leftmenu.communicationmoduleitemcampaign")}
                >
                  <label>{i18n.t("menu.leftmenu.communicationmoduleitemcampaign")}</label>
                </Link>
                <Link
                  to="campaigncreate"
                  title={i18n.t("menu.leftmenu.communicationmoduleitemcreatecampaign")}
                >
                  <label>{i18n.t("menu.leftmenu.communicationmoduleitemcreatecampaign")}</label>
                </Link>
                <Link
                  to="createhtml"
                  title={i18n.t("menu.leftmenu.communicationmoduleitemcreatehtml")}
                >
                  <label>{i18n.t("menu.leftmenu.communicationmoduleitemcreatehtml")}</label>
                </Link>
              </div>
            </li>
            {/* MENU COMUNICAÇÃO */}

            <hr style={{ width: "90%", marginBottom: "4px", marginTop: "0px" }} />

            {/* MENU CUPOM */}
            <li
              className="item_"
              id="profile"
              title={i18n.t("menu.leftmenu.couponmodule")}
            >

              <div className="col">
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <div className="btn">
                    {couponIcon}
                  </div>
                </div>
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <label style={{ fontSize: "smaller", fontFamily: "Roboto", color: "#755ff5" }}>{i18n.t("menu.leftmenu.couponmodule")}</label>
                </div>
              </div>
              <div id="itemMenu" className="smenu menu1">
                <Link
                  to="viewcoupons"
                  title={i18n.t("menu.leftmenu.couponmoduleitemcoupons")}
                >
                  <label>{i18n.t("menu.leftmenu.couponmoduleitemcoupons")}</label>
                </Link>
                <Link
                  to="validation"
                  title={i18n.t("menu.leftmenu.couponmoduleitemvalidate")}
                >
                  <label>{i18n.t("menu.leftmenu.couponmoduleitemvalidate")}</label>
                </Link>
              </div>
            </li>
            {/* MENU CUPOM */}

            {/* MENU Lead Page */}
            <li
              className="item_"
              id="leadpage"
              title={i18n.t("menu.leftmenu.landingpagemodule")}
            // style={{ display: "block" }}
            >
              <div className="col">
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <div className="btn">
                    {langindpageIcon}
                  </div>
                </div>
                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                  <label style={{ fontSize: "smaller", fontFamily: "Roboto", color: "#755ff5" }}>{i18n.t("menu.leftmenu.landingpagemodule")}</label>
                </div>
              </div>
              <div id="itemMenu2" className="smenu leadpagemenu">
                <Link to="mylandingpages">
                  <label>{i18n.t("menu.leftmenu.landingmoduleitempagbuilder")}</label></Link>
              </div>
            </li>
            {/* MENU Lead Page */}

            {/* MENU FIDELIDADE */}
            {/* <li className="item_" id="profile2" title="Módulo Fidelidade" style={{display: 'none'}}>
            <div className="btn">
            <svg style={{opacity: "0"}} height="28" viewBox="0 0 64 64" width="28" xmlns="http://www.w3.org/2000/svg"><circle cx="48" cy="32" fill="#9bc9ff" r="3"/><circle cx="43" cy="32" fill="#9bc9ff" r="3"/><path d="m41 13a9.957 9.957 0 0 1 .838-4h-34.838a4 4 0 0 0 -4 4v2h38.2a10.057 10.057 0 0 1 -.2-2z" fill="#9bc9ff"/><path d="m51 23a9.947 9.947 0 0 1 -5.982-2h-42.018v16a4 4 0 0 0 4 4h19v-4a4 4 0 0 1 8 0v4h19a4 4 0 0 0 4-4v-16h-.018a9.947 9.947 0 0 1 -5.982 2z" fill="#9bc9ff"/><path d="m57 21v-.014l-.018.014z" fill="#9bc9ff"/><g fill="#1e81ce"><path d="m62 13a10.993 10.993 0 0 0 -20.786-5h-34.214a5.006 5.006 0 0 0 -5 5v24a5.006 5.006 0 0 0 5 5h8.461l-2.561 5.771a5.024 5.024 0 0 0 .2 4.459l3.528 6.349a3.011 3.011 0 0 1 .372 1.458v.963a1 1 0 0 0 2 0v-.963a5.021 5.021 0 0 0 -.629-2.429l-3.528-6.349a3.018 3.018 0 0 1 -.119-2.676l2.926-6.583h7.35v7a1 1 0 0 0 2 0v-12a3 3 0 0 1 6 0v24a1 1 0 0 0 2 0v-12.54a5.969 5.969 0 0 0 4 1.54h3a1 1 0 0 0 1-1v-7h10a5.006 5.006 0 0 0 5-5v-15.521a10.986 10.986 0 0 0 4-8.479zm-11-9a9 9 0 1 1 -9 9 9.011 9.011 0 0 1 9-9zm-47 12h36.426a11 11 0 0 0 2.095 4h-38.521zm3-6h33.426a10.966 10.966 0 0 0 -.426 3c0 .338.021.67.051 1h-36.051v-1a3 3 0 0 1 3-3zm34 38h-2a4 4 0 0 1 -4-4v-2h6zm15-11a3 3 0 0 1 -3 3h-18v-3a5 5 0 0 0 -10 0v3h-18a3 3 0 0 1 -3-3v-15h40.7a10.923 10.923 0 0 0 11.3.786z"/><path d="m48 28a3.966 3.966 0 0 0 -2.49.894 4 4 0 1 0 0 6.212 3.992 3.992 0 1 0 2.49-7.106zm-7 4a2 2 0 0 1 2-2 1.968 1.968 0 0 1 1.3.486 3.946 3.946 0 0 0 0 3.028 1.968 1.968 0 0 1 -1.3.486 2 2 0 0 1 -2-2zm7 2a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z"/><path d="m21 31h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"/><path d="m15 31h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"/><path d="m9 31h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"/><path d="m48.293 17.707a1 1 0 0 0 1.414 0l7.071-7.071a1 1 0 1 0 -1.414-1.414l-6.364 6.364-2.293-2.293a1 1 0 0 0 -1.414 1.414z"/></g></svg>
            </div>
            <div id="itemMenu" className="smenu menu2">
            <Link to="coupon">Criar Cupom</Link>
            <Link to="viewcoupons">Seus Cupons</Link>
            </div>
            </li> */}
            {/* MENU FIDELIDADE */}

            {/* MENU CASHBACK */}
            {/* <li className="item_" id="profile2" title="Módulo CashBack">
            <div className="btn">
            <svg style={{opacity: "0.33"}} height="28px" viewBox="0 0 481 481.39127" width="28px" xmlns="http://www.w3.org/2000/svg"><g fill="#9bc9ff"><path d="m169.074219 185.390625-18.480469 32h55.441406l36.960938-64 58.800781-101.917969-41.519531-24-72.722656 125.917969zm0 0"/><path d="m360.195312 289.390625h96v-72c0-17.671875-14.328124-32-32-32h-36.558593l-18.480469 32h-277.121094l18.480469-32h-70.320313c-17.671874 0-32 14.328125-32 32v224c0 17.671875 14.328126 32 32 32h384c17.671876 0 32-14.328125 32-32v-72h-96c-17.671874 0-32-14.328125-32-32v-16c0-17.671875 14.328126-32 32-32zm0 0"/><path d="m384.195312 329.390625c0 8.835937-7.164062 16-16 16-8.835937 0-16-7.164063-16-16s7.164063-16 16-16c8.835938 0 16 7.164063 16 16zm0 0"/></g><path d="m480.195312 281.390625h-16v-64c-.027343-22.078125-17.917968-39.972656-40-40h-22.695312l21.601562-37.429687c3.183594-5.515626 4.046876-12.074219 2.398438-18.226563-1.652344-6.152344-5.679688-11.394531-11.199219-14.574219l-180.183593-104c-11.484376-6.542968-26.089844-2.617187-32.746094 8.800782l-95.472656 165.429687h-65.703126c-22.082031.027344-39.972656 17.921875-40 40v224c.027344 22.082031 17.917969 39.972656 40 40h384c22.082032-.027344 39.972657-17.917969 40-40v-64h16zm-70.925781-149.4375-44.730469 77.4375h-144.65625l84.855469-147.015625 101.601563 58.65625c3.773437 2.246094 5.070312 7.085938 2.929687 10.921875zm-244.816406 77.4375 98.75-170.992187 27.679687 16-89.464843 154.992187zm50.832031-189.429687c2.210938-3.816407 7.089844-5.121094 10.910156-2.921876l23.144532 13.359376-103.359375 178.992187h-40.089844zm232.910156 421.429687c0 13.253906-10.746093 24-24 24h-384c-13.253906 0-24-10.746094-24-24v-224c0-13.253906 10.746094-24 24-24h56.464844l-9.265625 16h-39.199219v16h368v-16h-33.183593l9.246093-16h31.9375c13.253907 0 24 10.746094 24 24v64h-88c-22.082031.027344-39.972656 17.921875-40 40v16c.027344 22.082031 17.917969 39.972656 40 40h88zm16-80h-104c-13.253906 0-24-10.746094-24-24v-16c0-13.253906 10.746094-24 24-24h104zm0 0" fill="#1e81ce"/><path d="m344.195312 329.390625c0 13.253906 10.746094 24 24 24 13.253907 0 24-10.746094 24-24s-10.746093-24-24-24c-13.253906 0-24 10.746094-24 24zm24-8c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8c-4.417968 0-8-3.582031-8-8s3.582032-8 8-8zm0 0" fill="#1e81ce"/></svg>
            </div>
            <div id="itemMenu" className="smenu menu2">
            <a href="">Configurações</a>
            </div>
            </li> */}
            {/* MENU CASHBACK */}

            {/* MENU GIFTCARD */}
            {/* <li className="item_" id="profile2" title="Módulo Gift Card">
            <div className="btn">
            <svg style={{opacity: "0.33"}}
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 64 64"
            >
            <g data-name="Gift voucher">
            <g fill="#9bc9ff">
            <path d="M37 13H19v10h18zM21 23h16v10H21zM43 13v10h18V13H45zM43 33h10v24h6V23H43zM25 43v4h8v-4h-7zM21 43h-8v4h8zM25 47h6v10h-6zM15 47h6v10h-6z"></path>
            <circle cx="47" cy="51" r="2"></circle>
            <circle cx="39" cy="43" r="2"></circle>
            </g>
            <path
            fill="none"
            d="M62 44l1-2M29 40a3 3 0 00-6 0 3 3 0 10-3 3h-7v4h2v10h16V47h2v-4h-7a3 3 0 003-3z"
            ></path>
            <circle cx="39" cy="43" r="2" fill="none"></circle>
            <circle cx="47" cy="51" r="2" fill="none"></circle>
            <path
            fill="#9bc9ff"
            d="M9 51V37a4 4 0 00-4-4H3v28h2a4 4 0 004-4z"
            ></path>
            <path
            fill="#1e81ce"
            d="M48.293 40.293l-12 12a1 1 0 101.414 1.414l12-12a1 1 0 00-1.414-1.414zM47 48a3 3 0 103 3 3 3 0 00-3-3zm0 4a1 1 0 111-1 1 1 0 01-1 1zM39 46a3 3 0 10-3-3 3 3 0 003 3zm0-4a1 1 0 11-1 1 1 1 0 011-1zM9 40a1 1 0 00-1 1v1a1 1 0 002 0v-1a1 1 0 00-1-1zM9 45a1 1 0 00-1 1v1a1 1 0 002 0v-1a1 1 0 00-1-1zM9 50a1 1 0 00-1 1v1a1 1 0 002 0v-1a1 1 0 00-1-1z"
            ></path>
            <path
            fill="#1e81ce"
            d="M61 12H49.46A5.994 5.994 0 1040 4.69 5.995 5.995 0 1030.54 12H19a1 1 0 00-1 1v10a1 1 0 001 1h1v8h-7a5 5 0 00-4 2 5 5 0 00-4-2H3a1 1 0 00-1 1v28a1 1 0 001 1h2a5 5 0 004-2 5 5 0 004 2h40a1 1 0 001-1v-3h5a1 1 0 001-1V24h1a1 1 0 001-1V13a1 1 0 00-1-1zM45 4a4 4 0 010 8h-4V8a4 4 0 014-4zm-3 28h-4V14h4zM31 8a4 4 0 018 0v4h-4a4 4 0 01-4-4zm-11 6h16v8H20zm2 10h14v8H22zm30 36H13a3 3 0 01-3-3 1 1 0 00-2 0 3 3 0 01-3 3H4V34h1a3 3 0 013 3 1 1 0 002 0 3 3 0 013-3h39zm6-4h-4V33a1 1 0 00-1-1h-9v-8h14zm2-34H44v-8h16z"
            ></path>
            <path
            fill="#1e81ce"
            d="M33 42h-3.556A3.959 3.959 0 0030 40a3.983 3.983 0 00-7-2.618A3.979 3.979 0 0016.556 42H13a1 1 0 00-1 1v4a1 1 0 001 1h1v9a1 1 0 001 1h16a1 1 0 001-1v-9h1a1 1 0 001-1v-4a1 1 0 00-1-1zM20 56h-4v-8h4zm0-10h-6v-2h6zm-2-6a2 2 0 014 0v2h-2a2 2 0 01-2-2zm6 16h-2V44h2zm0-16a2 2 0 112 2h-2zm6 16h-4v-8h4zm2-10h-6v-2h6z"
            ></path>
            </g>
            </svg>
            </div>
            <div id="itemMenu" className="smenu menu2">
            <a href="">Configurações</a>
            </div>
            </li> */}
            {/* MENU GIFTCARD */}

            <hr
              style={{ width: "90%", marginTop: "4px", marginBottom: "4px" }}
            />

            {/* MENU ADICIONAR ESTABELECIMENTOS */}
            <li
              className="item_"
              id="Estab"
              title={i18n.t("menu.leftmenu.branchmodule")}
            >
              <div className="btn">
                <div className="col">
                  <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                    <div className="btn">
                      {branchIcon}
                    </div>
                  </div>
                  <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                    <label style={{ fontSize: "smaller", fontFamily: "Roboto", color: "#755ff5" }}>{i18n.t("menu.leftmenu.branchmodule")}</label>
                  </div>
                </div>

              </div>
              <div id="itemMenu" className="smenu menuEstab">
                <Link to="addbranch"><label>{i18n.t("menu.leftmenu.branchmoduleitembranchs")}</label></Link>
                <Link to="addoperators"><label>{i18n.t("menu.leftmenu.branchmoduleitemoperators")}</label></Link>
              </div>
            </li>
            {/* MENU ADICIONAR ESTABELECIMENTOS */}



            {/* MENU PORTAL CLIENTE */}
            <li className="item_" id="profile2" title="Portal Cliente">
              <div className="btn">
                <svg
                  style={{ opacity: "0.33" }}
                  height="28"
                  viewBox="0 0 64 64"
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="Select">
                    <path
                      d="m59 3h-54a2 2 0 0 0 -2 2v10h58v-10a2 2 0 0 0 -2-2zm-50 8a2 2 0 1 1 2-2 2 2 0 0 1 -2 2zm8 0a2 2 0 1 1 2-2 2 2 0 0 1 -2 2zm8 0a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z"
                      fill="#9bc9ff"
                    />
                    <path
                      d="m14.83 24.17a4.025 4.025 0 0 0 -2.83-1.17h-4a4 4 0 0 1 -4 4 3.657 3.657 0 0 1 -1-.13v16.13h9v-12h4v-4a4.025 4.025 0 0 0 -1.17-2.83z"
                      fill="#9bc9ff"
                    />
                    <path
                      d="m60 27a4 4 0 0 1 -4-4h-4a3.995 3.995 0 0 0 -4 4v4h4v12h9v-16.13a3.657 3.657 0 0 1 -1 .13z"
                      fill="#9bc9ff"
                    />
                    <path
                      d="m42.83 24.17a4.025 4.025 0 0 0 -2.83-1.17h-4a4 4 0 0 1 -8 0h-4a3.995 3.995 0 0 0 -4 4v4h4v12h16v-12h4v-4a4.025 4.025 0 0 0 -1.17-2.83z"
                      fill="#9bc9ff"
                    />
                    <path d="m42 55 5-3.96-5-4.04z" fill="#9bc9ff" />
                    <path d="m22 47-5 4.04 5 3.96z" fill="#9bc9ff" />
                    <g fill="#1e81ce">
                      <path d="m59 2h-54a3 3 0 0 0 -3 3v54a3 3 0 0 0 3 3h54a3 3 0 0 0 3-3v-54a3 3 0 0 0 -3-3zm-6 27a1 1 0 0 0 -2 0v1h-2v-3a2.994 2.994 0 0 1 3-3h3.1a5.008 5.008 0 0 0 4.9 4v14h-7zm-49-24a1 1 0 0 1 1-1h54a1 1 0 0 1 1 1v9h-56zm8 19a2.994 2.994 0 0 1 3 3v3h-2v-1a1 1 0 0 0 -2 0v13h-7v-14a5.008 5.008 0 0 0 4.9-4zm47 36h-54a1 1 0 0 1 -1-1v-15h8a1 1 0 0 0 1-1v-11h3a1 1 0 0 0 1-1v-4a4.995 4.995 0 0 0 -5-5h-4a1 1 0 0 0 -1 1 3 3 0 0 1 -3 3v-10h56v10a3 3 0 0 1 -3-3 1 1 0 0 0 -1-1h-4a4.995 4.995 0 0 0 -5 5v4a1 1 0 0 0 1 1h3v11a1 1 0 0 0 1 1h8v15a1 1 0 0 1 -1 1z" />
                      <path d="m9 6a3 3 0 1 0 3 3 3 3 0 0 0 -3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1 -1 1z" />
                      <path d="m17 6a3 3 0 1 0 3 3 3 3 0 0 0 -3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1 -1 1z" />
                      <path d="m25 6a3 3 0 1 0 3 3 3 3 0 0 0 -3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1 -1 1z" />
                      <path d="m41 32h3a1 1 0 0 0 1-1v-4a4.995 4.995 0 0 0 -5-5h-4a1 1 0 0 0 -1 1 3 3 0 0 1 -6 0 1 1 0 0 0 -1-1h-4a4.995 4.995 0 0 0 -5 5v4a1 1 0 0 0 1 1h3v11a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1zm-2 10h-14v-13a1 1 0 0 0 -2 0v1h-2v-3a2.994 2.994 0 0 1 3-3h3.1a5 5 0 0 0 9.8 0h3.1a2.994 2.994 0 0 1 3 3v3h-2v-1a1 1 0 0 0 -2 0z" />
                      <path d="m42.628 46.222a1 1 0 0 0 -1.628.778v8a1 1 0 0 0 1.621.784l5-3.96a1 1 0 0 0 .007-1.562zm.372 6.71v-3.838l2.4 1.938z" />
                      <path d="m22.431 46.1a1 1 0 0 0 -1.059.124l-5 4.04a1 1 0 0 0 .007 1.562l5 3.96a1 1 0 0 0 1.621-.786v-8a1 1 0 0 0 -.569-.9zm-1.431 6.832-2.4-1.9 2.4-1.938z" />
                    </g>
                  </g>
                </svg>
              </div>
              <div id="itemMenu" className="smenu menu2">
                <a href="">Config</a>
              </div>
            </li>
            {/* MENU PORTAL CLIENTE */}

            {/* MENU APLICATIVO CLIENTE */}
            <li className="item_" id="profile2" title="Aplicativo PWA">
              <div className="btn">
                <svg
                  style={{ opacity: "0.33" }}
                  height="28px"
                  viewBox="0 0 480.74506 480"
                  width="28px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m264 8.464844h-160c-17.671875 0-32 14.324218-32 32v16h224v-16c0-17.675782-14.328125-32-32-32zm0 0"
                    fill="#9bc9ff"
                  />
                  <path
                    d="m208 128.464844h-96l-8 112h112zm0 0"
                    fill="#9bc9ff"
                  />
                  <path
                    d="m456 368.464844c0 30.925781-25.070312 56-56 56s-56-25.074219-56-56c0-30.929688 25.070312-56 56-56s56 25.070312 56 56zm0 0"
                    fill="#9bc9ff"
                  />
                  <path
                    d="m416.984375 56.519531c-30.925781-.359375-56.289063 24.417969-56.648437 55.34375-.359376 30.925781 24.417968 56.289063 55.34375 56.648438 30.925781.359375 56.289062-24.417969 56.648437-55.34375s-24.417969-56.289063-55.34375-56.648438zm0 0"
                    fill="#9bc9ff"
                  />
                  <path
                    d="m254.542969 355.296875 25.183593-25.183594c-6.273437 4.167969-14.359374 4.441407-20.902343.707031-6.542969-3.730468-10.421875-10.835937-10.023438-18.355468h-176.800781v32c0 17.671875 14.328125 32 32 32h146c-2.765625-7.339844-.988281-15.613282 4.542969-21.167969zm0 0"
                    fill="#9bc9ff"
                  />
                  <g fill="#1e81ce">
                    <path d="m160 24.464844h16v16h-16zm0 0" />
                    <path d="m192 24.464844h16v16h-16zm0 0" />
                    <path d="m160 336.464844h48v16h-48zm0 0" />
                    <path d="m324.96875 173.152344c.027344-7.425782-2.914062-14.554688-8.167969-19.800782-3.546875-3.457031-7.972656-5.871093-12.800781-6.976562v-105.910156c-.027344-22.082032-17.917969-39.976563-40-40h-160c-22.082031.023437-39.972656 17.917968-40 40v176.207031c-6.882812-5.296875-15.316406-8.179687-24-8.207031h-8c-8.835938 0-16 7.160156-16 16v115.664062c-.09375 30.363282 15.5625 58.605469 41.359375 74.621094l11.359375 7.097656c7.039062 4.367188 11.308594 12.070313 11.28125 20.351563v38.265625h16v-38.265625c.042969-13.804688-7.070312-26.640625-18.800781-33.917969l-11.359375-7.105469c-21.109375-13.101562-33.914063-36.207031-33.839844-61.046875v-115.664062h8c13.253906 0 24 10.742187 24 24v96c.027344 22.078125 17.917969 39.972656 40 40h141.105469c5.089843 8.105468 14.007812 13.011718 23.582031 12.964844 7.207031.003906 14.132812-2.792969 19.3125-7.796876v8.710938c-.027344 8.425781-4.445312 16.226562-11.65625 20.582031l-8.917969 5.363281c-12.023437 7.25-19.386719 20.253907-19.425781 34.292969v21.882813h16v-21.882813c.027344-8.425781 4.445312-16.226562 11.65625-20.582031l8.917969-5.359375c12.023437-7.253906 19.386719-20.257813 19.425781-34.296875v-24.625l12.800781-12.800781c10.933594-10.933594 10.933594-28.664063 0-39.597657-2.875-2.824218-6.351562-4.957031-10.167969-6.242187l10.167969-10.160156c10.933594-10.933594 10.933594-28.664063 0-39.597657-2.875-2.824218-6.351562-4.953124-10.167969-6.234374l10.167969-10.132813c10.933594-10.9375 10.933594-28.667969 0-39.601563-2.875-2.824218-6.351562-4.957031-10.167969-6.238281l10.167969-10.160156c5.253907-5.246094 8.195313-12.375 8.167969-19.800781zm-244.96875-132.6875c0-13.257813 10.746094-24 24-24h160c13.253906 0 24 10.742187 24 24v8h-208zm0 24h208v82.460937c-4.066406 1.246094-7.78125 3.4375-10.832031 6.402344l-28.28125 28.277344c-6.773438 6.714843-9.644531 16.425781-7.609375 25.746093 2.03125 9.316407 8.6875 16.949219 17.644531 20.230469l-10.035156 10.023438c-6.773438 6.714843-9.644531 16.425781-7.609375 25.746093 2.03125 9.316407 8.6875 16.949219 17.644531 20.230469l-10.035156 10.023438c-3.011719 3.058593-5.269531 6.777343-6.597657 10.859375h-162.289062zm0 280v-24h161.710938c2.164062 8.863281 8.625 16.050781 17.210937 19.140625l-10.035156 10.027343c-4.988281 5.019532-7.878907 11.753907-8.085938 18.832032h-136.800781c-13.253906 0-24-10.746094-24-24zm216.96875-15.3125c4.851562 0 9.226562 2.921875 11.082031 7.40625 1.859375 4.480468.832031 9.640625-2.59375 13.074218l-28.289062 28.285157c-4.746094 4.539062-12.222657 4.539062-16.96875 0-4.683594-4.683594-4.683594-12.28125 0-16.964844l30.640625-30.074219c1.847656-1.125 3.964844-1.71875 6.128906-1.726562zm0-56c4.851562 0 9.226562 2.921875 11.082031 7.40625 1.859375 4.480468.832031 9.640625-2.59375 13.074218l-29.90625 29.335938c-4.714843 3.34375-11.132812 2.90625-15.351562-1.050781-4.683594-4.683594-4.683594-12.28125 0-16.964844l30.640625-30.074219c1.847656-1.125 3.964844-1.71875 6.128906-1.726562zm0-56c4.851562 0 9.226562 2.921875 11.082031 7.40625 1.859375 4.480468.832031 9.640625-2.59375 13.074218l-29.90625 29.335938c-4.714843 3.34375-11.132812 2.90625-15.351562-1.050781-4.683594-4.683594-4.683594-12.28125 0-16.964844l30.640625-30.074219c1.847656-1.125 3.964844-1.71875 6.128906-1.726562zm8.488281-35.519532-29.90625 29.335938c-4.714843 3.34375-11.132812 2.90625-15.351562-1.050781-4.683594-4.683594-4.683594-12.28125 0-16.964844l28.289062-28.289063c4.707031-4.546874 12.191407-4.484374 16.820313.144532s4.695312 12.113281.148437 16.824218zm0 0" />
                    <path d="m104 248.464844h112c2.222656.003906 4.351562-.917969 5.867188-2.542969 1.519531-1.625 2.289062-3.808594 2.132812-6.027344l-8-112c-.296875-4.195312-3.792969-7.441406-8-7.429687h-16v-8c0-17.675782-14.328125-32-32-32s-32 14.324218-32 32v8h-16c-4.207031-.011719-7.703125 3.234375-8 7.429687l-8 112c-.15625 2.21875.613281 4.402344 2.132812 6.027344 1.515626 1.625 3.644532 2.546875 5.867188 2.542969zm40-136c0-8.839844 7.164062-16 16-16s16 7.160156 16 16v8h-32zm-24.550781 24h8.550781v16h16v-16h32v16h16v-16h8.550781l6.855469 96h-94.8125zm0 0" />
                    <path d="m408 328.464844h-16v8c-8.835938 0-16 7.160156-16 16v8c0 8.835937 7.164062 16 16 16h16v8h-32v16h16v8h16v-8c8.835938 0 16-7.164063 16-16v-8c0-8.839844-7.164062-16-16-16h-16v-8h32v-16h-16zm0 0" />
                    <path d="m400 304.464844c-35.347656 0-64 28.652344-64 64 0 35.34375 28.652344 64 64 64s64-28.65625 64-64c-.039062-35.332032-28.671875-63.960938-64-64zm0 112c-26.507812 0-48-21.492188-48-48 0-26.511719 21.492188-48 48-48s48 21.488281 48 48c-.027344 26.496094-21.5 47.972656-48 48zm0 0" />
                    <path d="m408 152.464844h16v-8c8.835938 0 16-7.164063 16-16v-8c0-8.839844-7.164062-16-16-16h-16v-8h32v-16h-16v-8h-16v8c-8.835938 0-16 7.160156-16 16v8c0 8.835937 7.164062 16 16 16h16v8h-32v16h16zm0 0" />
                    <path d="m352.335938 111.757812c-.417969 35.34375 27.894531 64.335938 63.238281 64.753907h.800781c35.347656.203125 64.164062-28.285157 64.367188-63.632813.203124-35.347656-28.285157-64.164062-63.628907-64.367187h-.800781c-35.039062.019531-63.546875 28.210937-63.960938 63.246093zm64-47.246093h.585937c25.933594.160156 46.851563 21.273437 46.769531 47.207031-.082031 25.9375-21.128906 46.917969-47.0625 46.917969-25.9375 0-46.984375-20.980469-47.066406-46.917969-.078125-25.933594 20.839844-47.046875 46.773438-47.207031zm0 0" />
                    <path d="m16 64.464844h16v16h-16zm0 0" />
                    <path d="m32 80.464844h16v16h-16zm0 0" />
                    <path d="m0 80.464844h16v16h-16zm0 0" />
                    <path d="m16 96.464844h16v16h-16zm0 0" />
                    <path d="m383.8125 232.367188.1875-16 15.996094.1875-.1875 16zm0 0" />
                    <path d="m399.902344 248.460938.1875-16 16 .1875-.1875 16zm0 0" />
                    <path d="m367.902344 248.273438.1875-16 16 .1875-.1875 16zm0 0" />
                    <path d="m383.808594 264.367188.1875-16 16 .1875-.1875 16zm0 0" />
                    <path d="m343.8125 16.371094.1875-16 16 .1875-.1875 16zm0 0" />
                    <path d="m359.90625 32.464844.1875-16 15.996094.1875-.1875 16zm0 0" />
                    <path d="m327.898438 32.277344.1875-16 16 .1875-.1875 16zm0 0" />
                    <path d="m343.8125 48.371094.1875-16 15.996094.1875-.1875 16zm0 0" />
                  </g>
                </svg>
              </div>
              <div id="itemMenu" className="smenu menu2">
                <a href="">Config</a>
                <a href="">Regras de Pontos</a>
                <a href="">Estabelecimentos</a>
                <a href="">Portal</a>
                <a href="">APP Mobil</a>
              </div>
            </li>
            {/* MENU APLICATIVO CLIENTE */}
          </div>
        </div>
      </div>
    );
  }
}

export default LeftMenu;
